import { useCallback, useEffect, useRef } from 'react'
import { useCFDContext } from './context/useCFDContext'
import OrderDisplayPage from '../../views/CustomerFacingDisplay/components/CFDOrderDetail'
import PaymentDetailsPage from '../../views/CustomerFacingDisplay/components/CFDPaymentDetail'
import { CFDClientMessageType } from 'pages/CustomerFacingDisplayPage/reducer/Interface'
import { CFDClientEvent } from '../../views/CustomerFacingDisplay/hardwareAgent/CFDClientEvent'
import { CFDSubjects } from '../../views/CustomerFacingDisplay/hardwareAgent/CFDSubjects'
import FinishPaymentPage from '../../views/CustomerFacingDisplay/components/CFDFinishPayment'
import CustomerFacingDisplayLayout from 'router/layouts/CustomerFacingDisplayLayout'
import useValidateConnection from './hook/useValidateConnection'
const LOOP_TIME_SECOND = 10000
const CFDMainPage = () => {
    const manualRetryConnection = useRef<NodeJS.Timeout | undefined>()

    const {
        state,
        onReceivePOSMessage,
        isHWOnline,
        isConnected,
        clientID,
        onConnectToPOS,
        onDisconnectedToPOS,
        isLoadedLocalSetting,
    } = useCFDContext()
    useValidateConnection(isLoadedLocalSetting)
    useEffect(() => {
        const subscription = CFDSubjects.subscribe((event) => {
            if (event.type === CFDClientEvent.OnReceiveMessage) {
                onReceivePOSMessage(event.params)
            }
        })

        return () => {
            subscription.unsubscribe()
        }
    }, [onReceivePOSMessage])
    const cleanLoopRetry = useCallback(() => {
        if (manualRetryConnection.current)
            clearInterval(manualRetryConnection.current)
    }, [])
    const loopRetryProcess = useCallback(
        (func: () => void) => {
            cleanLoopRetry()
            const attemptToStartConnection = () => {
                func()
            }
            manualRetryConnection.current = setInterval(
                () => attemptToStartConnection(),
                LOOP_TIME_SECOND,
            )
        },
        [cleanLoopRetry],
    )

    useEffect(() => {
        // Manually attempt to reconnect the signalR in case of losing connection whether due to the absence of
        // the HWAgent is disconnected from the network
        if (isHWOnline) {
            if (!isConnected && clientID) {
                onConnectToPOS()
                loopRetryProcess(onConnectToPOS)
                return
            }
        } else {
            onDisconnectedToPOS()
        }
        cleanLoopRetry()

        return () => {
            cleanLoopRetry()
        }
    }, [
        cleanLoopRetry,
        clientID,
        isConnected,
        isHWOnline,
        loopRetryProcess,
        onConnectToPOS,
        onDisconnectedToPOS,
    ])
    return (
        <CustomerFacingDisplayLayout>
            {state === CFDClientMessageType.Order ? (
                <OrderDisplayPage />
            ) : state === CFDClientMessageType.Payment ? (
                <PaymentDetailsPage />
            ) : state === CFDClientMessageType.FinishPayment ? (
                <FinishPaymentPage />
            ) : (
                <>Not support type</>
            )}
        </CustomerFacingDisplayLayout>
    )
}

export default CFDMainPage
